import React from 'react'
import { useSelector } from 'hooks'
import styled from 'styled-components'
import { darken } from 'styles'

const StyledThemePreview = styled.div`
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 8vw; /* each item has width: 25vw */
  box-shadow: 0 -10px 10px 10px ${p => p.theme.colors.mainBackground};

  div {
    flex: 1;
  }
  .main {
    background: ${p => p.theme.colors.main};
  }
  .main-dark {
    background: ${p => darken(0.1, p.theme.colors.main)};
  }
  .highlight {
    background: ${p => p.theme.colors.highlight};
  }
  .cta {
    background: ${p => p.theme.colors.cta};
  }
`

const ThemePreview = () =>
  useSelector(s => !!s.flags.themePreview) && (
    <StyledThemePreview>
      <div className="main" />
      <div className="main-dark" />
      <div className="highlight" />
      <div className="cta" />
    </StyledThemePreview>
  )

export default ThemePreview
